<template>
  <div class="sogym__fastfood">

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image" src="../../assets/images/gamburger.jpeg">

      <p class="sogym__fastfood--name">Sogym Burger</p>

      <p class="sogym__fastfood--price">1190 тнг</p>
    </div>

<!--    <div class="sogym__fastfood&#45;&#45;item">-->
<!--      <img alt="" class="sogym__fastfood&#45;&#45;image" src="../../assets/images/burger_1.png">-->

<!--      <p class="sogym__fastfood&#45;&#45;name">Гамбургер</p>-->

<!--      <p class="sogym__fastfood&#45;&#45;price">1290 тнг</p>-->
<!--    </div>-->

<!--    <div class="sogym__fastfood&#45;&#45;item">-->
<!--      <img alt="" class="sogym__fastfood&#45;&#45;image" src="../../assets/images/burger_1.png">-->

<!--      <p class="sogym__fastfood&#45;&#45;name">Чизбургер</p>-->

<!--      <p class="sogym__fastfood&#45;&#45;price">1190 тнг</p>-->
<!--    </div>-->

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image" src="../../assets/images/double.png">

      <p class="sogym__fastfood--name">Double Sogym Burger</p>

      <p class="sogym__fastfood--price">1390 тнг</p>
    </div>

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image"  src="../../assets/images/chiken.png">
      <p class="sogym__fastfood--name">Чикен 8шт / 16шт</p>

      <p class="sogym__fastfood--price">1590 тнг / 2890 тнг</p>
    </div>

    <div class="sogym__fastfood--item">

      <img alt="" class="sogym__fastfood--image" src="../../assets/images/naggets.png">
      <p class="sogym__fastfood--name">Наггетсы 5шт</p>

      <p class="sogym__fastfood--price">790 тнг</p>
    </div>

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image" src="../../assets/images/pizza.png">

      <p class="sogym__fastfood--name">Маргарита</p>

      <p class="sogym__fastfood--price">1890 тнг</p>
    </div>

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image" src="../../assets/images/peppe.png">

      <p class="sogym__fastfood--name">Мясная</p>

      <p class="sogym__fastfood--price">2050 тнг</p>
    </div>

    <div class="sogym__fastfood--item">
      <img alt="" class="sogym__fastfood--image" src="../../assets/images/dolki.png">

      <p class="sogym__fastfood--name">Картофель дольками</p>

      <p class="sogym__fastfood--price">600 тнг</p>
    </div>



  </div>

</template>


<script>

export default {
  data () {
    return {
      news: [
        true,
        false,
        false,
        false
      ],
      allProducts: [],
      categories: [],
      comments: [
        {
          id: 1,
          title: '@aigul_kazhenbay',
          text: 'Спасибо за моментальную доставку мы за оперативность',
          star: 5
        },
        {
          id: 2,
          title: '@taganovazhaniia',
          text: 'Фарш таза өте дәмді',
          star: 5
        },
        {
          id: 3,
          title: '@klaraturniiazova',
          text: 'Фарш у них отличное',
          star: 5
        },
        {
          id: 4,
          title: '@serik_km_kz',
          text: 'Еттерің жақсы екен! Алла разы болсын',
          star: 5
        }
      ]
    }
  },
  created: function () {
    setInterval(this.updateTicker, 4000);
  },
  methods: {
    updateTicker: function () {
      let removed = this.news.pop();
      this.news.unshift(removed);
    },
    getCategories () {
      this.categories = []
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/all/categories", config).then((res) => {
        this.categories = res.data;
        this.getProducts()
      });
    },
    async getProducts () {
      this.allProducts = [];
      for (let i = 0; i < this.categories.length; i++) {
        await this.$http.post("guest/get/products/by/category",
            {
              per_page: 50,
              category_id: this.categories[i].id
            }).then((res) => {
          this.allProducts.push(res.data)
        });
      }

    },
    chunkArray (array) {
      const perChunk = 2 // items per chunk
      const inputArray = array
      const result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk)

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [] // start a new chunk
        }

        resultArray[chunkIndex].push(item)

        return resultArray
      }, [])
      return result
    }
  },
  computed: {},
  mounted () {
    this.getCategories()
  }

}
</script>

<style lang="scss">
.sogym__fastfood {
  display: flex;
  flex-wrap: wrap;

  padding: 50px;

  .sogym__fastfood--item {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 350px;

    .sogym__fastfood--name {
      font-size: 30px;
      font-weight: bold;
    }

    .sogym__fastfood--price {
      font-size: 20px;
      color: #f79528;
      font-weight: bold;
    }

    .sogym__fastfood--image {
      width: 300px;

    }
  }

}
</style>